import React, { MouseEvent } from 'react';

interface BedIconProps {
  className?: string;
  onClick?: (event: MouseEvent) => void;
}

const BedIcon = ({ className, onClick }: BedIconProps) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
      <path d="M13.8096 4.99988C13.8096 4.24035 13.1882 3.61891 12.4287 3.61891V1.54747C12.4287 0.787938 11.8072 0.166504 11.0477 0.166504H2.76193C2.0024 0.166504 1.38096 0.787938 1.38096 1.54747V3.61891C0.621434 3.61891 0 4.24035 0 4.99988V8.45229H0.918341L1.38096 9.83325H2.07145L2.53407 8.45229H11.2825L11.7382 9.83325H12.4287L12.8913 8.45229H13.8096V4.99988ZM11.0477 3.61891H7.5953V1.54747H11.0477V3.61891ZM2.76193 1.54747H6.21434V3.61891H2.76193V1.54747ZM1.38096 4.99988H12.4287V7.07132H1.38096V4.99988Z" fill="#191B1E"/>
    </svg>
  );
};

export default BedIcon;